import React from 'react';

const WallPlaceholder = () => {
    return (
        <ul className="listview image-listview media placeholder-glow mb-2">
            <li>
                <a href="#" className="item">
                    <div className="icon-box bg-primary placeholder"></div>
                    <div className="in">
                        <span className="placeholder col-6"></span>
                        <span className="placeholder col-2"></span>
                    </div>
                </a>
            </li>
            <li>
                <a href="#" className="item">
                    <div className="icon-box bg-secondary placeholder"></div>
                    <div className="in">
                        <span className="placeholder col-5"></span>
                        <span className="placeholder col-2"></span>
                    </div>
                </a>
            </li>
            <li>
                <a href="#" className="item">
                    <div className="icon-box bg-danger placeholder"></div>
                    <div className="in">
                        <span className="placeholder col-4"></span>
                        <span className="placeholder col-2"></span>
                    </div>
                </a>
            </li>
        </ul>
    );
};

export default WallPlaceholder;
